const handleize = (str) => {
	try {
		str = str
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "") // Remove accents
			.replace(/([^\w]+|\s+)/g, "-") // Replace space and other characters by hyphen
			// eslint-disable-next-line no-useless-escape
			.replace(/\-\-+/g, "-") // Replaces multiple hyphens by one hyphen
			.toLowerCase() // To lowercase

		return str
	} catch (err) {
		console.error("handleize catched error", err)
		return ""
	}
}

export default handleize
